import { FormItem } from '@framework/form';
import { Collapse } from 'antd';
import * as React from 'react';
import { BooleanConditionEditorInput } from '../../../../../../inputs/expressions-editor/conditions/BooleanConditionEditorInput';
import { StyledDrawerCollapse } from '../../../../../../ui/drawer/StyledDrawerCollapse';
import { WidgetDirectivesInput } from '../../../../../directives/WidgetDirectivesInput';
import { Widget } from '../../../../Widget';
import { WidgetRepository } from '../../../WidgetRepository';
const { Panel } = Collapse;

export interface ITableWidgetConfigFormProps {
  widget?: Widget | null;
}

/**
 * Form di configurazione del widget all'interno di una tabella di input.
 * Si potrebbe unificare anche nel `WidgetConfigDrawer`.
 */
export function TableWidgetConfigForm(props: ITableWidgetConfigFormProps) {
  const { widget } = props;
  const widgetType = WidgetRepository.find(widget?.type);

  if (!widgetType || !widget) return null;

  return (
    <div>
      {/* Se si rimuove il collapse di default mostriamo direttamente il componente
se necessario il Collapse deve essere gestito nel componente */}
      {widgetType.configComponent && (
        <>
          {widgetType.configOptions?.removeCollapsePanel && (
            <>
              <widgetType.configComponent widget={widget} />
              <WidgetDirectivesInput widget={widget} widgetType={widgetType} />
            </>
          )}
        </>
      )}
      <StyledDrawerCollapse defaultActiveKey={['rules', 'general']} ghost>
        {widgetType.configComponent && (
          <>
            {widgetType.configOptions?.removeCollapsePanel ? null : (
              <Panel header="Impostazioni Generali" key="general">
                <widgetType.configComponent widget={widget} />
                <WidgetDirectivesInput
                  widget={widget}
                  widgetType={widgetType}
                />
              </Panel>
            )}
          </>
        )}
        {widgetType.rules.length > 0 && (
          <Panel header="Regole di Validazione" key="rules">
            {widgetType.rules.map((rule, index) => (
              <rule.configComponent key={index} />
            ))}
          </Panel>
        )}
        <Panel
          header="Regole di Visualizzazione"
          key="2"
          collapsible="disabled"
        >
          <FormItem name="visible" label="Visibilità">
            <BooleanConditionEditorInput name="visible" label="Visibile" />
          </FormItem>
          <FormItem name="enabled" label="Abilitato">
            <BooleanConditionEditorInput name="enabled" label="Abilitato" />
          </FormItem>
        </Panel>
      </StyledDrawerCollapse>
    </div>
  );
}
